<template>
	<div>
		<div id="map"/>
		<o-select
			:ref="setup._address"
			v-model="setup.address"
			v-bind="$attrs"
			:label="setup.displayedLabel"
			:prefill-search="modelValue"
			autocomplete
			suffix-font-icon="icon-travel-map-location-pin"
			track-key="place_id"
			display-key="description"
			:custom-fetch="setup.getGooglePredictionsAsync.bind(setup)"
			@select="setup.handleSelect($event)">
			<template #after-options>
				<div class="powered-by-google">
					<img src="@Img/powered_by_google_on_white_hdpi.png">
				</div>
			</template>
		</o-select>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedGoogleAutoCompleteEmits, SharedGoogleAutoCompleteProps } from './SharedGoogleAutoCompleteSetup';
import SharedGoogleAutoCompleteSetup from './SharedGoogleAutoCompleteSetup';
const emits = defineEmits<SharedGoogleAutoCompleteEmits>() as SharedGoogleAutoCompleteEmits;
const props = withDefaults(defineProps<SharedGoogleAutoCompleteProps>(), SharedGoogleAutoCompleteSetup.defaultProps);
const setup = new SharedGoogleAutoCompleteSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
.powered-by-google {
	padding: 0.3rem 0.3rem 0 0;
	text-align: right;

	> img {
		display: inline-block;
		height: 0.8rem;
	}
}
</style>
